export enum UploadTypeEnum {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION',
  EVENT = 'EVENT',
  EMAIL_TEMPLATE = 'EMAIL_TEMPLATE'
}
